//#region src/dom/children.ts
function getElementChildren(parent, predicate) {
	const children = [];
	for (let index = 0; index < parent.children.length; index++) {
		const child = parent.children.item(index);
		if (child && predicate(child, index)) children.push(child);
	}
	return children;
}
function findElementChild(parent, predicate) {
	for (let index = 0; index < parent.children.length; index++) {
		const child = parent.children.item(index);
		if (child && predicate(child, index)) return child;
	}
	return null;
}
/**
* Return what an element composes: the elements assigned to a slot, or otherwise its own children.
*
* A slot with nothing assigned yields its fallback content, so the result always describes what renders.
*/
function getComposedChildren(parent) {
	if (parent instanceof HTMLSlotElement) {
		const assigned = parent.assignedElements();
		if (assigned.length > 0) return assigned;
	}
	return [...parent.children];
}
function findComposedElement(root, predicate) {
	const children = getComposedChildren(root);
	for (const [index, child] of children.entries()) {
		if (predicate(child, index)) return child;
		const nested = findComposedElement(child, predicate);
		if (nested) return nested;
	}
	return null;
}
/** Follow a single-child relationship from the root until it ends or cycles. */
function followElementPath(root, getNext) {
	const path = [];
	const visited = /* @__PURE__ */ new Set();
	let current = root;
	while (current && !visited.has(current)) {
		path.push(current);
		visited.add(current);
		current = getNext(current);
	}
	return path;
}
//#endregion
export { findComposedElement, findElementChild, followElementPath, getComposedChildren, getElementChildren };

//# sourceMappingURL=children.js.map